// extracted by mini-css-extract-plugin
module.exports = {"title":"popup_title__JIDoA","flag":"popup_flag__j_Ln0","prompt":"popup_prompt___ni_4","cta":"popup_cta__tf1ZL","outro-cta":"popup_outro-cta__jC22q","yellow":"popup_yellow__vIsNN"};